import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=460584dc&"
import script from "./OfferPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferPage.vue?vue&type=style&index=0&id=460584dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports